import { Obj } from "../../object/obj/Obj.js";
class RenderDrawObj extends Obj {
  render(draw, config) {
    try {
      this.beforeDraw(draw);
      draw.context.save();
      if (!config?.disableReset) {
        draw.reset?.();
      }
      this.draw(draw);
      draw.context.restore();
      this.afterDraw(draw);
    } catch (e) {
      console.error("error!!", e);
      this.error(e);
    }
  }
  beforeDraw(draw) {
  }
  afterDraw(draw) {
  }
  error(e) {
  }
  // constructor(canvas: HTMLCanvasElement, context: CanvasRenderingContext2D, public avaliablePlace: Rectangle = new Rectangle(new Point(0, 0), new Point(0, 0))) {
  //     super(canvas, context);
  // }
  // get centerPoint(): Point {
  //     return new Point();
  // }
}
export {
  RenderDrawObj
};
//# sourceMappingURL=RenderDrawObj.js.map
